import { IUserPreferences } from 'gen/ApiClient';
import React from 'react';

interface IContext {
	userPreferences: IUserPreferences;
	reload: VoidFunction;
}

export const UserPreferencesPreloadCacheContext = React.createContext<IContext>(undefined as any);
